const toggleEventsLanguageSelect = {
	el: {
		body: document.querySelector('body'),
		modalLanguageSelect: document.querySelector('.js-modal-language'),
		buttonModalLanguageSelect: document.querySelectorAll('.js-toggle-modal-language')
	},

	fxToggleModalLanguageSelect(el) {
		this.el.body.classList.toggle('no-scroll-hidden')
		el.classList.toggle('header__modal--open')
	},

	events() {
		// Event for open and close modal
		this.el.buttonModalLanguageSelect.forEach(el => el.addEventListener('click', () => this.fxToggleModalLanguageSelect(this.el.modalLanguageSelect)))
	},

	init() {
		this.events()
	}
}

toggleEventsLanguageSelect.init()